import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { userType } from "../../config/userType";
import { selectUser } from "../../features/Auth/selectAuth";
import routes from "../../config/routeConfig";

export default function PrivateRoute({ children, role = userType[1] }) {
  const user = useSelector(selectUser);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  function sendToOwnLoginPath() {
    if (role === userType[0]) {
      navigate(routes.admin.login);
    } else if (role === userType[1]) {
      navigate(routes.student.login);
    }
  }

  useEffect(() => {
    if (!user) {
      sendToOwnLoginPath();
    } else if (user.role !== role) {
      sendToOwnLoginPath();
    }

    setIsLoading(false);
  }, [user, navigate]);

  return <>{isLoading ? <p>Loading...</p> : children}</>;
}
